import state from './admin.state'
import mutations from './admin.mutations'
import actions from './actions'

export default {
  state,
  mutations,
  actions
}
